import styled from 'styled-components/macro'
import { rem, media } from '../../../utils/styles'
// import { fieldBMargin, fieldHMargin } from '../utils/styles'

const shadow = '1px 1px 5px rgba(0, 0, 0, .25)'

const OptionsList = styled.ul`
  position: absolute;
  top: calc(100% - .5em);
  left: 1.5em;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: ${rem(174)};
  background: #fff;
  box-shadow: ${shadow};
  overflow-y: auto;
  z-index: 100;

  ${media('tablet')`
    width: calc(100% - 3em);
  `}

  &:focus {
    outline: 0;
  }
`

export default OptionsList
